import React from "react";
import { FlatList, Image, RefreshControl, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Body, Container, Icon, Tab, Left, Right, Button, Tabs } from "native-base";
import Header from "../../components/ui/WrappedHeader";
import { connect } from "react-redux";
import LoadingIndicator from "../../components/ui/LoadingIndicator";
import { Actions, ActionTypes, INITIAL_STATE, reducer } from "../../redux/screens/homework/NewListRedux";
import { ActionTypes as HomeworkActionTypes } from "../../redux/utils/HomeworkRedux";
import { NavigationService } from "../../navigation";
import UIDs from "../../UIDs";
import { withTranslation } from "react-i18next";
import AuthorizedScreen from "../../components/base/AuthorizedScreen";
import { AppSizes } from "../../theme";
import CustomText from "../../components/ui/CustomText";
import MessageBox from "../../components/ui/MessageBox";
// import { Actions as OfflineStorageActions } from "../../redux/actionTypes/utils/OfflineStorageActionTypes";

const uid = UIDs.screens.homework.newhistorylist;

let t;
class NewHistoryListScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null },
            [ActionTypes.UPDATE_SCREEN_IN_BACKGROUND_ASYNC]: { done: null, error: null /* no need to display error for background action */ },
            [HomeworkActionTypes.LOAD_HOMEWORK_DATA_ASYNC]: { done: null, error: action => this.displayAsyncActionError(action.error, "loadHomeWorkDataFailure") },
            [ActionTypes.REFRESH_SCREEN_ASYNC]: { done: null, error: action => this.displayAsyncActionError(action.error, "refreshScreenFailure") },
            [ActionTypes.REPORT_OFFLINE_PROBLEM_ASYNC]: { done: this._handleReportOfflineProblemAsyncDone, error: this._handleAsyncActionError },
        };
    }

    localVars = {
        navParams: {},
        activeTab: 0,
        firstLoad: true,
    };

    constructor(props) {
        super(props);
        this.localVars.navParams = NavigationService.getNavParams(props);

        if(this.localVars.navParams.activeTab){
            this.localVars.activeTab = this.localVars.navParams.activeTab;
        }
        t = props.t;
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.loadScreenViewAsync();
        // this.props.navigation.setParams({ reQuery: this.props.refreshScreenAsync });
    }

    // shouldComponentUpdate(nextProps, nextState) {
    //     const { activeTab } = NavigationService.getNavParams(nextProps);
    //     if (_.isNumber(activeTab) && activeTab !== this.localVars.activeTab) {
    //         // this.tabs.goToPage(activeTab);
    //         this.localVars.activeTab = activeTab;
    //     }
    //
    //     return true;
    // }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        let receivedHomeworkId = this.props.localState.receivedHomeworkId;
        let receivedUserHomeworkId = this.props.localState.receivedUserHomeworkId;
        if (receivedHomeworkId && receivedUserHomeworkId !== prevProps.localState.receivedUserHomeworkId) {
            this.props.loadHomeworkDataAsync(receivedHomeworkId);
        }

        // const { reload } = NavigationService.getNavParams(this.props);
        // if (reload) {
        //     let { params } = this.props.navigation.state;
        //     let { navParams = {} } = params;
        //     navParams.reload = false;
        //     this.props.navigation.setParams(params);
        //
        //     //第一次打开页面不要reload
        //     if (this.localVars.firstLoad) {
        //         this.localVars.firstLoad = false;
        //     } else {
        //         this.props.refreshScreenAsync();
        //     }
        // }

        if (!prevProps.localState.needUpdateInBackground && this.props.localState.needUpdateInBackground) {
            this.props.updateScreenInBackgroundAsync();
        }
    }

    renderScreen() {
        if (!this.isActionDone(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)) return <LoadingIndicator />;

        const { newList, historyList } = this.props.localState;
        return (
            <Container>
                <Header style={styles.header}>
                    <Left style={{flex: 1}}>
                        <Button transparent onPress={this._handleClose}>
                            <Icon name="ios-arrow-back" style={[styles.closeIcon, styles.closeIconSize]} />
                        </Button>
                    </Left>
                    <Body style={{alignItems:"center"}}>
                        <Text style={styles.headerText}>{t("history")}</Text>
                    </Body>
                    <Right style={{flex: 1}}/>
                </Header>
                <View style={{flex: 1}}>
                    {this._renderList(historyList, 1)}
                </View>
            </Container>
        );
    }

    _renderList = (data, index) => {
        return(
            <View style={styles.listContainer}>
                {data.length > 0 ? (
                    <FlatList
                        data={data}
                        keyExtractor={item => item.userHomeworkId}
                        renderItem={data => this._renderItem(data, index)}
                        ItemSeparatorComponent={this._separator}
                        refreshControl={
                            <RefreshControl
                                tintColor="#ffb007"
                                colors={["#ffb007"]}
                                refreshing={this.isActionExecuting(ActionTypes.REFRESH_SCREEN_ASYNC)}
                                onRefresh={() => this.props.refreshScreenAsync()}
                            />
                        }
                        onEndReached={() => this._loadMore(index)}
                        onEndReachedThreshold={0.1}
                    />
                ) : (
                    <View style={styles.noneContainer}>
                        <Image source={require("../../images/homework/noRecord.png")} style={styles.noneImage} resizeMode="contain"></Image>
                        <CustomText style={styles.noneText}>{t(index === 0 ? "noNew" : "noHistory")}</CustomText>
                    </View>
                )}
            </View>
        )
    }

    _renderTab = (heading, data, index) => {
        return (
            <Tab
                tabStyle={{ backgroundColor: "#fff", height:0 }}
                activeTabStyle={{ backgroundColor: "#fff" }}
                textStyle={{ color: "#000", fontSize: 14 }}
                activeTextStyle={{ color: "#000", fontSize: 17 }}
                heading={""}>
                <View style={styles.listContainer}>
                    {data.length > 0 ? (
                        <FlatList
                            data={data}
                            keyExtractor={item => item.userHomeworkId}
                            renderItem={data => this._renderItem(data, index)}
                            ItemSeparatorComponent={this._separator}
                            refreshControl={
                                <RefreshControl
                                    tintColor="#ffb007"
                                    colors={["#ffb007"]}
                                    refreshing={this.isActionExecuting(ActionTypes.REFRESH_SCREEN_ASYNC)}
                                    onRefresh={() => this.props.refreshScreenAsync()}
                                />
                            }
                            onEndReached={() => this._loadMore(index)}
                            onEndReachedThreshold={0.1}
                        />
                    ) : (
                        <View style={styles.noneContainer}>
                            <Image source={require("../../images/homework/noRecord.png")} style={styles.noneImage} resizeMode="contain"></Image>
                            <CustomText style={styles.noneText}>{t(index === 0 ? "noNew" : "noHistory")}</CustomText>
                        </View>
                    )}
                </View>
            </Tab>
        );
    };

    _renderItem = (data, tabIndex) => {
        const { homeworkDone } = this.props.localState;
        const { item } = data;
        const { name, dueTime, status, overdue, homeworkId, userHomeworkId } = item;
        const download = homeworkDone.has(homeworkId);
        // const localStatus = offlineStorageHelper.getHomeworkStatus(item.userHomeworkId);
        // let localStatusRender = null;
        // let taskIcon = null;
        // if (localStatus && _.isNumber(localStatus)) {
        //     const pendingTaskCount = offlineStorageHelper.getHomeworkPendingTaskCount(item.userHomeworkId);
        //
        //     if (pendingTaskCount > 0) {
        //         taskIcon = (
        //             <TouchableOpacity onPress={() => this.hasPendingChangeAlert(userHomeworkId)} style={AppStyles.alignSelfEnd}>
        //                 <MaterialIcons style={{ color: AppColors.brand.warning, fontSize: 20 }} name="sync-problem" />
        //             </TouchableOpacity>
        //         );
        //     }
        //     if (localStatus === StatusEnum.Pending) {
        //         localStatusRender = (
        //             <View style={[styles.download, { backgroundColor: "#43A4F8" }]}>
        //                 <Text style={styles.downloadText}>{t("pending")}</Text>
        //             </View>
        //         );
        //     } else if (localStatus === StatusEnum.Pending) {
        //         localStatusRender = (
        //             <View style={[styles.download, { backgroundColor: "#43A4F8" }]}>
        //                 <Text style={styles.downloadText}>{t("pendingWithError")}</Text>
        //             </View>
        //         );
        //     } else if (localStatus === StatusEnum.PendingSubmitting) {
        //         localStatusRender = (
        //             <View style={[styles.download, { backgroundColor: "#43A4F8" }]}>
        //                 <Text style={styles.downloadText}>{t("pendingWithError")}</Text>
        //             </View>
        //         );
        //     }
        // }

        return tabIndex == 0 ? (
            <View style={styles.item}>
                <View style={{ flex: 1, marginLeft: 8, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                    <CustomText style={[styles.name]} numberOfLines={1}>
                        {name}
                    </CustomText>
                    <View style={{ flexDirection: "row", alignItems: "center" }}>
                        <CustomText style={[styles.duetime, overdue && { color: "red" }]}>
                            {t("duetime")}: {dueTime}
                        </CustomText>
                        {!download && (
                            <View style={[styles.download, { backgroundColor: "#43A4F8" }]}>
                                <Text style={styles.downloadText}>{t("downloading")}</Text>
                            </View>
                        )}
                        {/*{localStatusRender}*/}
                        {/*{taskIcon}*/}
                    </View>
                </View>
                <View style={{ marginRight: 8 }}>
                    <TouchableOpacity
                        style={[styles.startBtn, { backgroundColor: tabIndex === 0 && download ? "#ffb007" : "transparent", justifyContent: "center", alignItems: "center" }]}
                        onPress={() => this._handleAction(item, tabIndex)}
                        disabled={tabIndex === 0 && !download}>
                        <Text style={styles.btnText}>{t(status === 0 ? "start" : "continue")}</Text>
                    </TouchableOpacity>
                </View>
            </View>
        ) : (
            <TouchableOpacity style={styles.item} onPress={() => this._handleAction(item, tabIndex)}>
                <View style={{ flex: 1, marginLeft: 8, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                    <CustomText style={[styles.name]} numberOfLines={1}>
                        {name}
                    </CustomText>
                </View>
                <View>
                    <Icon type="FontAwesome" name="angle-right" style={{ fontSize: 16, color: "#555", alignSelf: "flex-end" }} />
                </View>
            </TouchableOpacity>
        );
    };

    _loadMore = tabIndex => {
        if (tabIndex === 0) {
            //new
            const { newListParams } = this.props.localState;
            const { pageIndex, pageSize, hasMore } = newListParams;
            if (hasMore) {
                this.props.loadMoreAsync({ pageIndex: pageIndex + 1, pageSize, type: tabIndex });
            }
        }
        if (tabIndex === 1) {
            //history
            const { historyListParams } = this.props.localState;
            const { pageIndex, pageSize, hasMore } = historyListParams;
            if (hasMore) {
                this.props.loadMoreAsync({ pageIndex: pageIndex + 1, pageSize, type: tabIndex });
            }
        }
    };

    _separator = () => {
        return <View style={[styles.separator]} />;
    };

    // hasPendingChangeAlert = userHomeworkId => {
    //     if (this.props.isConnected) {
    //         Alert.alert("", this.props.t("thisGameHasPendingChangeOnline"), [
    //             {
    //                 text: this.props.t("cancel"),
    //                 onPress: () => {
    //                     // do nothing
    //                 },
    //                 style: "cancel",
    //             },
    //             {
    //                 text: this.props.t("report"),
    //                 onPress: () => {
    //                     // report for this game
    //                     let vo = offlineStorageHelper.buildHomeworkOfflineProblemVO(userHomeworkId);
    //                     this.props.reportOfflineProblemAsync(vo);
    //                 },
    //             },
    //         ]);
    //     } else {
    //         Alert.alert("", this.props.t("thisGameHasPendingChange"));
    //     }
    // };

    _handleReportOfflineProblemAsyncDone = () => {
        MessageBox.success({
            text: this.props.t("reportSuccess"),
            position: "center",
            duration: 3000,
        });
    };

    _handleAction = (item, tabIndex) => {
        if (tabIndex === 0) {
            const { homeworkId, userHomeworkId, homeworkAssignmentId } = item;
            NavigationService.navigateToPage(this, UIDs.screens.homework.homeworkunit, { homeworkId, homeworkAssignmentId, userHomeworkId, type: 0 });
        } else {
            NavigationService.navigateToPage(this, UIDs.screens.homework.historypreview, { userHomeworkId: item.userHomeworkId });
        }
    };

    _handleClose = () => {
        NavigationService.navigateToPage(this, UIDs.screens.homework.newdefault);
    };

    _handleAsyncActionError = action => {
        this.displayError(action.error);
    };
}

const styles = StyleSheet.create({
    header: {
        backgroundColor: "#fff",
        elevation: 0,
        borderBottomWidth: 1,
        borderBottomColor: "#f4f4f4",
    },
    headerText: {
        fontSize: 18,
        fontWeight: "bold",
    },
    tabs: {
        //backgroundColor: "#ffb007",
        // width: AppSizes.screen.widthQuarter,
        //height: 4,
        height: 0,
        //marginHorizontal: AppSizes.screen.widthQuarter/2,
        //borderRadius: 50,
    },
    listContainer: {
        backgroundColor: "#eee",
        paddingTop: 0,
        flex: 1
    },
    noneContainer: {
        backgroundColor: "#fff",
        justifyContent: "center",
        alignItems: "center",
        padding: 30,
        flex:1,
    },
    noneImage: {
        width: 120,
        height: 120,
        marginTop: 30,
    },
    noneText: {
        color: "#888",
    },
    separator: {
        borderBottomColor: "#eee",
        borderBottomWidth: StyleSheet.hairlineWidth,
        marginLeft: 80,
    },
    item: {
        flexDirection: "row",
        justifyContent: "space-between",
        backgroundColor: "#fff",
        paddingVertical: 15,
        paddingHorizontal: 10,
        alignItems: "center",
    },
    name: {
        color: "#555",
    },
    duetime: {
        color: "#888",
        fontSize: 10,
        marginTop: 5,
        lineHeight: 18,
    },
    startBtn: {
        width: 80,
        height: 26,
        borderRadius: 13,
    },
    btnText: {
        color: "#fff",
        fontSize: 12,
    },
    download: {
        width: 66,
        height: 18,
        borderRadius: 10,
        marginLeft: 5,
        marginTop: 5,
        //alignSelf: "flex-end",
        justifyContent: "center",
        alignItems: "center",
    },
    downloadText: {
        color: "#fff",
        fontSize: 8,
    },
    closeIcon: {
        color: "#2D2D2D",
    },
    closeIconSize:{
        fontSize:30
    },
});

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
        user: state.session.user,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: () => dispatch(Actions.loadScreenViewAsync()),
        // loadHomeworkDataAsync: homeworkId => dispatch(OfflineStorageActions.addHomeworkDownloadTaskAndStart([homeworkId])),
        updateScreenInBackgroundAsync: () => dispatch(Actions.updateScreenInBackgroundAsync()),
        refreshScreenAsync: () => dispatch(Actions.refreshScreenAsync()),
        loadMoreAsync: vo => dispatch(Actions.loadMoreAsync(vo)),
        // reportOfflineProblemAsync: vo => dispatch(Actions.reportOfflineProblemAsync(vo)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(NewHistoryListScreen));
